import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { sendHeartbeat, refreshGrantedPosition, GPS_REFRESH_MS } from '../utils/visitorTracking';

const HEARTBEAT_MS = 60 * 1000;
const isTrackedPath = (path) => !path.startsWith('/admin') && !path.startsWith('/login');

// Anonymous presence signal for the admin « Visiteurs » page.
const useVisitorTracking = () => {
  const location = useLocation();
  const pathRef = useRef(location.pathname);
  pathRef.current = location.pathname;

  useEffect(() => {
    if (isTrackedPath(location.pathname)) sendHeartbeat();
  }, [location.pathname]);

  useEffect(() => {
    refreshGrantedPosition();
    const tick = () => {
      if (document.visibilityState === 'visible' && isTrackedPath(pathRef.current)) sendHeartbeat();
    };
    const timer = setInterval(tick, HEARTBEAT_MS);
    const gpsTimer = setInterval(() => {
      if (document.visibilityState === 'visible' && isTrackedPath(pathRef.current)) refreshGrantedPosition();
    }, GPS_REFRESH_MS);
    document.addEventListener('visibilitychange', tick);
    return () => {
      clearInterval(timer);
      clearInterval(gpsTimer);
      document.removeEventListener('visibilitychange', tick);
    };
  }, []);
};

export default useVisitorTracking;
